import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const ResourcesFilledIcon = props => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={25}
    viewBox="0 0 26 25"
    fill="none"
    {...props}>
    <Path
      fill="#3876AA"
      fillRule="evenodd"
      d="M22.334 24.667H5A4.667 4.667 0 0 1 .333 20V2.59C.333 1.168 1.741.266 2.98.696c.177.062.35.15.516.268l.233.167a3.346 3.346 0 0 0 3.884-.006 4.693 4.693 0 0 1 5.441 0 3.346 3.346 0 0 0 3.884.006l.233-.167c1.324-.945 3.163.001 3.163 1.628v10.076H25a1 1 0 0 1 1 1V21a3.667 3.667 0 0 1-3.666 3.667Zm-1.667-10V21A1.667 1.667 0 1 0 24 21v-6.333h-3.333ZM15 9a1 1 0 0 0-1-1H6a1 1 0 1 0 0 2h8a1 1 0 0 0 1-1Zm-1.333 4a1 1 0 0 0-1-1H6a1 1 0 0 0 0 2h6.667a1 1 0 0 0 1-1ZM14 16a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2h8Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default ResourcesFilledIcon;
